import {
	SET_TYPES,
	SET_CONTACTS,
	SET_ORGANISATION_STRUCTURE,
	SIGNOUT_USER,
	SET_AREA_TYPES,
	REMOVE_ORGANISATION_USER,
	ADD_ORGANISATION_USER,
	ADD_ORGANISATION_GROUP,
	UPDATE_ORGANISATION_CONTACTS
} from 'constants/ActionTypes';

const INITIAL_STATE = {
	chatTemplates: [],
	types: [],
	areaTypes: [],
	organisationStructure: {
		organisationId: null,
		name: null,
		email: null,
		phone: null,
		avatar: {
			image: null,
			initials: null,
			square: false
		},
		location: {
			address: {
				zip: null,
				city: null,
				street: null
			},
			latlng: {
				lat: null,
				lng: null
			}
		},
		groups: [],
		users: [],
		organisationRoles: [],
		pdfExportSettings: {
			selectAllImages: false,
			workflow: false,
			chat: false,
			comments: false
		},
		passwordRequirements: {
			minPasswordLength: 8,
			minPasswordCategories: 3
		},
		responsibilityAreas: [],
		modules: {},
		navigation: {},
		reportRecordCols: []
	},
	contacts: { private: [], global: [] },
	userSettings: {
		observeReportsAfterAssignmentRemoval: true,
		showFinalizedReports: false
	},
	deadlineSettings: { automatedDeadlinesActive: false, automatedDeadlineDays: [] },
	prioritySettings: { automatedPriorityActive: false, automatedPriorities: [] },
	loading: {
		types: true,
		contacts: true,
		organisationStructure: true
	}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SIGNOUT_USER:
			return INITIAL_STATE;
		case SET_TYPES:
			return { ...state, types: action.payload.types, loading: { ...state.loading, types: false } };
		case SET_CONTACTS:
			return { ...state, contacts: action.payload.contacts, loading: { ...state.loading, contacts: false } };
		case SET_ORGANISATION_STRUCTURE:
			return {
				...state,
				organisationStructure: action.payload.organisationStructure,
				loading: { ...state.loading, organisationStructure: false }
			};
		case SET_AREA_TYPES:
			return {
				...state,
				areaTypes: action.payload.types
			};
		case REMOVE_ORGANISATION_USER:
			return {
				...state,
				organisationStructure: {
					...state.organisationStructure,
					users: state.organisationStructure.users.filter(u => u.userId !== action.payload.userId)
				}
			};
		case ADD_ORGANISATION_USER:
			return {
				...state,
				organisationStructure: {
					...state.organisationStructure,
					users: [...state.organisationStructure.users, action.payload.newUser]
				}
			};
		case ADD_ORGANISATION_GROUP:
			return {
				...state,
				organisationStructure: {
					...state.organisationStructure,
					groups: [...state.organisationStructure.groups, action.payload.newGroup]
				}
			};
		case UPDATE_ORGANISATION_CONTACTS:
			return {
				...state,
				contacts: { private: action.payload.contacts, global: state.contacts.global }
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/AccountSettings.js